// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kqL7A","input":"styles_input__MiDGE"};